import { Storage } from '../lib/storage';
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PackageOpen, Clock, Store, Crown, ShieldCheck, MapPin, Search, Send, Plus, CheckCircle, Navigation, Info, Lock, Loader2, Compass, AlertOctagon, Phone, Edit3, Users, Star, X, QrCode, Save } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import { supabase } from '../lib/supabase';

export default function TallerScreen() {
  const [modalAbierto, setModalAbierto] = useState(false);
  const [qrModalAbierto, setQrModalAbierto] = useState(false);
  const [modalGpsExito, setModalGpsExito] = useState(false);
  const [modalGpsReinicio, setModalGpsReinicio] = useState(false);
  const [precio, setPrecio] = useState('');
  const [tiempo, setTiempo] = useState('');
  const [cotizaciones, setCotizaciones] = useState<any[]>([]);
  const [cotizacionesEnviadas, setCotizacionesEnviadas] = useState<any[]>([]);
  const [cotizacionActual, setCotizacionActual] = useState<any>(null);
  const [enviando, setEnviando] = useState(false);

  // Estados Cierre Servicio (Opción B Postpago)
  const [modalCierreAbierto, setModalCierreAbierto] = useState(false);
  const [valorFinal, setValorFinal] = useState('');
  const [cerrando, setCerrando] = useState(false);

  const userStr = Storage.get('gravity_user');
  const soyEmpleado = userStr ? JSON.parse(userStr).rol === 'empleado_taller' : false;

  const formatSentenceCase = (val: string) => val ? val.charAt(0).toUpperCase() + val.slice(1) : '';

  const enviarCotizacion = async () => {
    if (!precio || !tiempo) return alert("Llena el precio y tiempo estimado.");
    if (!cotizacionActual) return;
    setEnviando(true);
    try {
        const payload = {
            taller_id: perfilTaller.id,
            taller_nombre: perfilTaller.nombre,
            precio_oferta: parseFloat(precio.toString().replace(/\D/g, '')),
            tiempo_oferta: tiempo,
            estado: 'respondida'
        };
        const { error } = await supabase.from('cotizaciones').update(payload).eq('id', cotizacionActual.id);
        if (error) throw error;
        
        setModalAbierto(false);
        setCotizaciones(cotizaciones.filter(c => c.id !== cotizacionActual.id));
        setCotizacionesEnviadas([{...cotizacionActual, precio_oferta: parseFloat(precio), tiempo_oferta: tiempo, estado: 'respondida'}, ...cotizacionesEnviadas]);
        setCotizacionActual(null);
        alert("¡Oferta enviada con éxito al motero!");
    } catch(e) {
        alert("Error al enviar oferta. ¿Creaste la tabla cotizaciones?");
    } finally {
        setEnviando(false);
    }
  };

  // ESTADOS DEL PERFIL PÚBLICO
  const [perfilTaller, setPerfilTaller] = useState<any>(null);
  const [cargandoPerfil, setCargandoPerfil] = useState(true);
  const [formEspecialidad, setFormEspecialidad] = useState('');
  const [guardandoPerfil, setGuardandoPerfil] = useState(false);

  // ESTADOS EDICION PERFIL PÚBLICO
  const [editModalAbierto, setEditModalAbierto] = useState(false);
  const [guardandoEdicion, setGuardandoEdicion] = useState(false);
  const [editForm, setEditForm] = useState({
    nombre: '',
    especialidad: '',
    ciudad: '',
    direccion: ''
  });

  useEffect(() => {
    const fetchPerfil = async () => {
      const myId = Storage.get('gravity_user_id');
      if (!myId) { setCargandoPerfil(false); return; }

      try {
        const { data, error } = await supabase
          .from('talleres_aliados')
          .select('*')
          .eq('usuario_id', myId)
          .order('created_at', { ascending: false })
          .limit(1)
          .single();

        if (data) {
          if (!data.especialidad) {
            setPerfilTaller({ ...data, incompleto: true });
          } else {
            setPerfilTaller(data);
          }
        }
      } catch (e) {
        console.error("No se encontró taller para este dueño.", e);
      } finally {
        setCargandoPerfil(false);
      }
    };
    fetchPerfil();
  }, []);

  useEffect(() => {
    if (!perfilTaller || perfilTaller.rating < 0) return;
    const fetchCots = async () => {
      try {
        const { data } = await supabase.from('cotizaciones')
          .select('*')
          .eq('estado', 'abierta')
          .or(`taller_id.is.null,taller_id.eq.${perfilTaller.id}`)
          .order('created_at', { ascending: false });
        if (data) setCotizaciones(data);

        const { data: enviadas } = await supabase.from('cotizaciones')
          .select('*')
          .in('estado', ['respondida', 'ejecutada'])
          .eq('taller_id', perfilTaller.id)
          .order('created_at', { ascending: false });
        
        if (enviadas) {
          // Lógica de Orden Inteligente y Límite de Historial
          const pendientes = enviadas.filter(c => c.estado === 'respondida');
          const historial = enviadas.filter(c => c.estado === 'ejecutada').slice(0, 30);
          setCotizacionesEnviadas([...pendientes, ...historial]);
        }
      } catch (e) {}
    };
    fetchCots();
    const iv = setInterval(fetchCots, 5000);
    return () => clearInterval(iv);
  }, [perfilTaller]);

  const activarPerfil = async () => {
    if (!formEspecialidad.trim()) return alert("Por favor escribe la especialidad de tu taller.");
    setGuardandoPerfil(true);
    const myId = Storage.get('gravity_user_id');
    try {
      const { error } = await supabase
        .from('talleres_aliados')
        .update({ especialidad: formEspecialidad, distancia: 'Calculando...' })
        .eq('usuario_id', myId);
      
      if (!error && perfilTaller) {
        setPerfilTaller({ ...perfilTaller, incompleto: false, especialidad: formEspecialidad, distancia: 'Calculando...' });
      } else {
        alert("Hubo un error guardando el perfil.");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setGuardandoPerfil(false);
    }
  };

  const abrirEdicion = () => {
    if (perfilTaller) {
      setEditForm({
        nombre: perfilTaller.nombre || '',
        especialidad: perfilTaller.especialidad || '',
        ciudad: perfilTaller.ciudad || '',
        direccion: perfilTaller.direccion || ''
      });
      setEditModalAbierto(true);
    }
  };

  const guardarEdicion = async () => {
    if (!editForm.nombre || !editForm.especialidad) {
      return alert("El Nombre y la Especialidad son obligatorios.");
    }
    setGuardandoEdicion(true);
    const myId = Storage.get('gravity_user_id');
    
    const cambioUbicacion = (editForm.direccion !== perfilTaller.direccion) || (editForm.ciudad !== perfilTaller.ciudad);
    
    const payloadUpdate: any = { 
       nombre: editForm.nombre,
       especialidad: editForm.especialidad,
       ciudad: editForm.ciudad,
       direccion: editForm.direccion
    };
    
    if (cambioUbicacion) {
       payloadUpdate.latitud = null;
       payloadUpdate.longitud = null;
    }

    try {
      const { error } = await supabase
        .from('talleres_aliados')
        .update(payloadUpdate)
        .eq('usuario_id', myId);
      
      if (!error && perfilTaller) {
        setPerfilTaller({ 
          ...perfilTaller, 
          nombre: editForm.nombre,
          especialidad: editForm.especialidad,
          ciudad: editForm.ciudad,
          direccion: editForm.direccion,
          ...(cambioUbicacion ? { latitud: null, longitud: null } : {})
        });
        setEditModalAbierto(false);
        if (cambioUbicacion && perfilTaller.latitud) {
           setTimeout(() => setModalGpsReinicio(true), 500);
        }
      } else {
        alert("Hubo un error al actualizar los datos.");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setGuardandoEdicion(false);
    }
  };

  if (cargandoPerfil) {
    return (
      <div className="flex flex-col h-full items-center justify-center opacity-50">
        <Loader2 className="w-8 h-8 text-gold-cert animate-spin mb-3" />
        <span className="text-xs font-bold uppercase tracking-widest text-gold-cert">Cargando Tablero...</span>
      </div>
    );
  }

  // PANTALLA 1: COMPLETAR PERFIL (RUTA 2 - NIVEL DIOS)
  if (perfilTaller?.incompleto) {
    return (
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="flex flex-col h-full items-center justify-center p-5 text-center">
        <div className="w-24 h-24 rounded-full bg-gold-cert/10 flex items-center justify-center mb-6 border border-gold-cert/30 shadow-[0_0_30px_rgba(251,191,36,0.2)]">
          <Store className="w-10 h-10 text-gold-cert" />
        </div>
        <h2 className="text-2xl font-black text-gold-cert mb-2">¡Felicidades, Aliado ORO!</h2>
        <p className="text-xs text-text-muted mb-8 leading-relaxed max-w-sm">
          Auditoría ha verificado tus documentos. El botón de tu panel B2B acaba de ser activado. Para encender el radar y empezar a recibir notificaciones de clientes varados, <strong className="text-white">crea tu Perfil Público:</strong>
        </p>

        <div className="w-full text-left space-y-4 max-w-sm">
          <div className="bg-slate-800/80 border border-slate-700 p-4 rounded-xl shadow-lg">
            <label className="text-[10px] font-black text-primary-cyan uppercase tracking-widest block mb-2">Especialidad Principal del Taller</label>
            <textarea 
              value={formEspecialidad}
              onChange={e => setFormEspecialidad(formatSentenceCase(e.target.value))}
              placeholder="Ej: Sistemas eléctricos, llantas, arrastres..." 
              maxLength={100}
              rows={5}
              className="w-full bg-transparent text-white font-bold text-sm outline-none placeholder:text-slate-500 border-b border-white/10 focus:border-gold-cert pb-2 transition-colors resize-none"
            ></textarea>
            <p className="text-[9px] text-text-muted mt-2">Así te verán todos los moteros en el mapa.</p>
          </div>
          
          <button 
            onClick={activarPerfil}
            disabled={guardandoPerfil}
            className="w-full py-4 bg-gold-cert text-yellow-950 font-black text-sm uppercase tracking-widest rounded-xl hover:shadow-[0_0_20px_#fbbf24] active:scale-95 transition-all outline-none flex items-center justify-center gap-2"
          >
            {guardandoPerfil ? <Loader2 className="w-5 h-5 animate-spin" /> : <Compass className="w-5 h-5" />}
            {guardandoPerfil ? 'Guardando...' : 'Encender Radar Público'}
          </button>
        </div>
      </motion.div>
    );
  }

  // PANTALLA 2: NO HAY TALLER AÚN APROBADO
  if (!perfilTaller) {
    return (
      <div className="flex flex-col h-full items-center justify-center p-5 text-center">
        <Store className="w-12 h-12 text-slate-600 mb-4" />
        <h2 className="text-xl font-bold text-white mb-2">Tablero Desactivado</h2>
        <p className="text-sm text-text-muted">Aún no tienes un Taller aprobado por la administración de Pikis Hub o faltan configurar permisos en tu usuario.</p>
      </div>
    );
  }

  // PANTALLA 2.5: TALLER SUSPENDIDO O INACTIVO
  if (perfilTaller.rating < 0) {
    return (
      <div className="flex flex-col h-full items-center justify-center p-8 text-center bg-danger-red/5 rounded-3xl m-2 border border-danger-red/20 shadow-inner">
        <AlertOctagon className="w-16 h-16 text-danger-red mb-4 animate-pulse opacity-80" />
        <h2 className="text-xl font-black text-danger-red mb-2 uppercase tracking-wide">Cuenta Suspendida</h2>
        <p className="text-xs text-text-muted mb-8 leading-relaxed">
          Tu cuenta comercial ha sido inhabilitada temporalmente por anomalías. 
          En este estado no podrás recibir licitaciones y tu taller fue retirado del mapa público.
        </p>
        <a 
          href={`https://wa.me/573013310246?text=Hola,%20soy%20el%20taller%20${encodeURIComponent(perfilTaller.nombre)}%20y%20aparezco%20suspendido.`} 
          target="_blank"
          className="w-full py-4 px-6 bg-danger-red/10 border border-danger-red/30 text-danger-red font-bold rounded-xl active:scale-95 transition-all hover:bg-danger-red hover:text-white flex gap-2 items-center justify-center text-xs uppercase tracking-widest"
        >
          <Phone className="w-4 h-4" /> Hablar con Auditoría
        </a>
      </div>
    );
  }

  // PANTALLA 3: TABLERO DE MANDO (EL ORIGINAL Y YA COMPLETADO)

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col h-full relative"
    >
      <div className="flex justify-between items-start mb-6 border-b border-white/5 pb-4">
        <div>
           <h2 className="text-xl font-extrabold mb-1">Bandeja B2B</h2>
           <p className="text-text-muted text-[13px] leading-tight">
              {perfilTaller.nombre}
           </p>
           <span className="inline-block mt-2 text-primary-cyan font-bold px-2 py-0.5 bg-primary-cyan/10 rounded border border-primary-cyan/20 text-[9px] uppercase tracking-widest">
             Aliado Validado
           </span>
        </div>
        
        <div className="flex flex-col items-end gap-2.5">
          <div className="flex items-center gap-2">
            {!soyEmpleado && (
              <button 
                onClick={abrirEdicion}
                className="bg-white/5 border border-white/10 hover:bg-white/10 py-1.5 px-3 rounded-lg flex items-center gap-1.5 transition-colors active:scale-95"
              >
                <Edit3 className="w-3.5 h-3.5 text-text-muted" />
                <span className="text-[9px] font-bold uppercase tracking-widest text-text-muted">Editar</span>
              </button>
            )}
            {!soyEmpleado && (
              <button 
                onClick={() => setQrModalAbierto(true)}
                className="bg-primary-cyan/10 border border-primary-cyan/30 hover:bg-primary-cyan/20 py-1.5 px-3 rounded-lg flex items-center gap-1.5 transition-colors active:scale-95 shadow-[0_0_10px_rgba(0,168,255,0.1)]"
              >
                <Users className="w-3.5 h-3.5 text-primary-cyan" />
                <span className="text-[9px] font-bold uppercase tracking-widest text-primary-cyan">Staff</span>
              </button>
            )}
          </div>
          
          {/* El Score del Taller Flotante */}
          <div className="bg-gradient-to-r from-gold-cert/20 to-yellow-600/10 border border-gold-cert/40 px-3 py-1.5 rounded-lg flex items-center gap-2 shadow-[0_0_15px_rgba(251,191,36,0.15)] backdrop-blur-sm">
            <Star className="w-4 h-4 fill-gold-cert text-gold-cert" />
            <div className="flex flex-col">
               <span className="text-gold-cert font-black text-[12px] leading-none mb-0.5">{perfilTaller.rating ? Number(perfilTaller.rating).toFixed(1) : '5.0'} pts</span>
               <span className="text-[7px] text-yellow-500/70 font-bold uppercase tracking-widest leading-none">SCORE ORO</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* FASE 2: EL BOTÓN ANCLA DE RADARES GPS (SOLO VISIBLE SI NO TIENE COORDENADAS) */}
      {(!perfilTaller.latitud) && (
      <div className="mb-6 mt-1">
        <div className="bg-yellow-500/10 border border-yellow-500/30 p-2.5 rounded-t-xl text-center">
          <p className="text-[10px] text-yellow-500 font-bold uppercase tracking-wide leading-tight truncate whitespace-nowrap">
            ⚠️ NEGOCIOS CON GPS ANCLADO RECIBEN 40% + CLIENTES.
          </p>
        </div>
        <button 
          onClick={() => {
            if (!navigator.geolocation) return alert('GPS no soportado en tu dispositivo.');
            
            const btn = document.getElementById('btn-gps-taller');
            if (btn) btn.innerHTML = '🛰️ RASTREANDO SATELITE...';
            
            navigator.geolocation.getCurrentPosition(async (pos) => {
              try {
                const { latitude, longitude } = pos.coords;
                const { error } = await supabase.from('talleres_aliados')
                  .update({ latitud: latitude, longitud: longitude })
                  .eq('id', perfilTaller.id);
                  
                if (error) {
                  console.error(error);
                  alert('⚠️ Error de DB: Pídele a Administración que cree las columnas "latitud" y "longitud" tipo float en Supabase.');
                } else {
                  setPerfilTaller({...perfilTaller, latitud: latitude, longitud: longitude});
                  setModalGpsExito(true);
                }
              } catch (e) {
                  alert('⚠️ Error de conexión GPS.');
              } finally {
                  if (btn) btn.innerHTML = '📡 FIJAR MIS COORDENADAS (OPRIMIR AQUÍ)';
              }
            }, () => {
              alert('❌ GPS DENEGADO o APAGADO. Enciende la "Ubicación" en tu celular y dale permisos a la App.');
              if (btn) btn.innerHTML = '📡 FIJAR MIS COORDENADAS (OPRIMIR AQUÍ)';
            }, { enableHighAccuracy: true });
          }}
          id="btn-gps-taller"
          className="w-full py-2 bg-danger-red/90 hover:bg-danger-red text-white font-black text-[10.5px] uppercase tracking-wide rounded-b-xl shadow-[0_5px_20px_rgba(239,68,68,0.3)] transition-all flex items-center justify-center gap-1.5 px-2 active:scale-95 border border-red-500/50 leading-tight"
        >
          <Compass className="w-4 h-4 text-white/90" />
          <span className="mt-0.5">FIJAR MIS COORDENADAS (OPRIMIR AQUÍ)</span>
        </button>
      </div>
      )}

      <div className="flex justify-between items-center mb-4 mt-2">
        <h4 className="font-black text-[15px] text-gold-cert flex items-center gap-2 uppercase tracking-wide">
          <PackageOpen className="w-4 h-4" /> 
          LICITACIONES (RADIO 5KM)
        </h4>
        {cotizaciones.length > 0 && (
          <span className="bg-danger-red/20 text-danger-red px-2 py-[2px] rounded-full text-[10px] font-bold animate-pulse">
            {cotizaciones.length} NUEVA{cotizaciones.length > 1 ? 'S' : ''}
          </span>
        )}
      </div>
      
      {/* Sistema de Licitaciones REAL */}
      {cotizaciones.length > 0 ? (
        <div className="space-y-4 mb-8">
          {cotizaciones.map((cot) => (
            <div key={cot.id} className="bg-gradient-to-br from-[#1e293b] to-slate-900 border border-gold-cert/40 rounded-[24px] p-5 relative overflow-hidden shadow-[0_10px_30px_rgba(251,191,36,0.12)]">
              <div className="absolute top-0 right-0 w-40 h-40 bg-gold-cert/10 rounded-full blur-[50px] -mr-10 -mt-10 pointer-events-none"></div>
              
              <div className="flex justify-between items-start mb-4 relative z-10">
                <div>
                  <strong className="text-[14px] font-black text-gold-cert leading-none uppercase tracking-wide">SOLICITUD DE AUXILIO</strong>
                  <p className="text-text-muted text-[10px]">Licitación Libre • Hace instantes</p>
                </div>
              </div>
              
              <div className="bg-black/40 rounded-2xl p-4 mb-5 text-[13px] font-medium text-slate-300 border border-white/5 shadow-inner">
                <span className="text-white font-bold block mb-1 uppercase text-[10px] tracking-widest">Detalle del problema:</span>
                <span className="leading-snug">"{cot.detalle_solicitud}"</span>
              </div>
              
              <div className="flex justify-center mt-1 pb-1 gap-2">
                <button 
                  onClick={() => { setCotizacionActual(cot); setModalAbierto(true); }}
                  className="flex-1 max-w-[250px] py-2 px-4 bg-gradient-to-r from-primary-cyan to-blue-600 rounded-xl font-bold text-[12px] tracking-wide hover:shadow-[0_0_15px_rgba(0,168,255,0.4)] active:scale-95 transition-all text-white flex items-center justify-center gap-2"
                >
                  <Plus className="w-3.5 h-3.5" /> Enviar Mi Cotización (Ofertar)
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-gradient-to-b from-[#162031] to-[#0f172a] border border-white/10 rounded-2xl p-8 text-center shadow-[0_8px_30px_rgba(0,0,0,0.6)]">
          <div className="mx-auto w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mb-3 border border-white/5 shadow-inner">
             <PackageOpen className="w-5 h-5 text-slate-500" />
          </div>
          <strong className="text-white block mb-1 text-[13px] tracking-wide">Bandeja despejada</strong>
          <p className="text-slate-400 text-[11px]">No hay solicitudes pendientes en tu zona de alcance.</p>
        </div>
      )}

      {/* Historial de Cotizaciones del Taller */}
      <div className="flex justify-between items-center mb-1 mt-6">
        <h4 className="font-black text-[15px] text-primary-cyan flex items-center gap-2 uppercase tracking-wide">
          <Send className="w-4 h-4" /> 
          OFERTAS QUE HAS ENVIADO
        </h4>
      </div>
      
      {/* ADVERTENCIA DE LÍMITE DE OFERTAS (EMBUDO ANTI-EVASIÓN) */}
      <div className="mb-4">
        <p className="text-[10px] text-primary-cyan leading-tight bg-primary-cyan/10 border border-primary-cyan/20 p-2 rounded-lg">
          ⚠️ Tienes un máximo de 3 ofertas simultáneas. Debes presionar "Reportar Servicio Finalizado" para recibir nuevas cotizaciones de Moteros.
        </p>
      </div>
      
      {cotizacionesEnviadas.length > 0 ? (
        <div className="space-y-4 hover:opacity-100 transition-opacity">
          {cotizacionesEnviadas.map((cot) => (
            <div key={cot.id} className="bg-black/60 border border-primary-cyan/40 rounded-[24px] p-5 relative overflow-hidden shadow-[0_10px_40px_rgba(0,168,255,0.08)] transform transition hover:-translate-y-0.5">
               <div className="absolute bottom-0 left-0 w-40 h-40 bg-primary-cyan/10 rounded-full blur-[50px] -ml-10 -mb-10 pointer-events-none"></div>
               <div className="flex justify-between items-start mb-3 relative z-10">
                 <h4 className="font-black text-white text-[14px] truncate pr-4 leading-tight uppercase">RESPUESTA A: {cot.detalle_solicitud}</h4>
                 <div className={`px-2 py-0.5 border text-[10px] uppercase font-black rounded tracking-widest shrink-0 ${cot.estado === 'ejecutada' ? 'bg-green-500/10 border-green-500/30 text-green-400' : 'bg-primary-cyan/10 border-primary-cyan/30 text-primary-cyan'}`}>
                   {cot.estado === 'ejecutada' ? 'Completada' : 'Enviada'}
                 </div>
               </div>
               <div className="flex justify-between mt-3 text-[13px] text-slate-400">
                 <span>Cobro: <strong className="text-white text-[14px]">${cot.precio_oferta?.toLocaleString('es-CO')}</strong></span>
                 <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-slate-500" /> {cot.tiempo_oferta}</span>
               </div>

               {cot.estado !== 'ejecutada' ? (
                 <div className="mt-4 pt-4 border-t border-white/5">
                   <button 
                     onClick={() => { setCotizacionActual(cot); setModalCierreAbierto(true); }}
                     className="w-full py-3.5 bg-green-500/10 text-green-400 border border-green-500/20 hover:bg-green-500 hover:text-white transition-colors rounded-xl text-xs font-black uppercase tracking-widest flex items-center justify-center gap-1.5 active:scale-95"
                   >
                     <CheckCircle className="w-4 h-4 mb-0.5" /> Reportar Servicio Finalizado
                   </button>
                 </div>
               ) : (
                 <div className="mt-4 pt-4 border-t border-white/5 flex flex-col items-center justify-center gap-1.5 text-slate-400 text-[11px] font-bold uppercase tracking-wide">
                   <p className="flex items-center gap-1"><CheckCircle className="w-3.5 h-3.5 text-slate-500" /> Auditoría B2B Registrada con éxito.</p>
                   {cot.comision_generada && <p className="text-yellow-500 bg-yellow-500/10 px-3 py-1 rounded-lg border border-yellow-500/20 shadow-inner">Cartera Acumulada: ${cot.comision_generada.toLocaleString('es-CO')}</p>}
                 </div>
               )}
            </div>
          ))}
        </div>
      ) : (
        <div className="bg-gradient-to-b from-[#162031] to-[#0f172a] border border-white/10 rounded-2xl p-6 px-10 text-center shadow-[0_8px_30px_rgba(0,0,0,0.6)]">
           <p className="text-slate-400 text-xs font-semibold tracking-wide">Aún no has respondido a ninguna licitación B2B.</p>
        </div>
      )}
      
      {/* Spacer para asegurar que la lista salte sobre el botón SOS inflado */}
      <div className="h-32 w-full shrink-0"></div>

      {/* Modal Interactivo (Proceso de Oferta B2B) */}
      <AnimatePresence>
        {modalAbierto && (
          <motion.div 
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            className="fixed inset-0 z-[100] bg-[#0f172a] flex flex-col pt-10 px-5 pb-24 overflow-y-auto"
          >
            <h2 className="text-2xl font-black mb-6 border-b border-white/10 pb-4">Cotizar Servicio</h2>
            
            <label className="text-xs text-text-muted mb-2 uppercase font-bold tracking-widest text-primary-cyan">
              ¿Cuál es tu mejor precio en pesos? (Incluyendo instalación)
            </label>
            <div className="relative mb-6">
              <span className="absolute left-4 top-[17px] text-text-muted font-bold">$</span>
              <input 
                type="tel" 
                value={precio}
                onChange={e => {
                   let raw = e.target.value.replace(/\D/g, '');
                   if (!raw) { setPrecio(''); return; }
                   setPrecio(Number(raw).toLocaleString('es-CO'));
                }}
                placeholder="150.000" 
                className="w-full p-4 pl-8 rounded-xl border border-slate-700 bg-bg-card text-white font-bold text-lg outline-none focus:border-gold-cert focus:shadow-[0_0_15px_rgba(251,191,36,0.2)]" 
              />
            </div>

            <label className="text-xs text-text-muted mb-2 uppercase font-bold tracking-widest text-primary-cyan">
              Tiempo estimado de solución
            </label>
            <textarea 
              value={tiempo}
              onChange={e => setTiempo(formatSentenceCase(e.target.value))}
              placeholder="Ej: Llego en 10 min y lo monto en media hora. También revisaré el estado de tu cadena para que sigas rodando seguro..." 
              rows={6}
              className="w-full p-4 rounded-xl border border-slate-700 bg-bg-card text-white font-medium text-sm outline-none focus:border-gold-cert mb-8 resize-none" 
            ></textarea>

            <div className="bg-blue-500/10 border border-blue-500/20 p-4 rounded-xl text-left mb-auto">
               <p className="text-[10px] text-blue-400 font-bold uppercase tracking-wide mb-1">Nota de Plataforma Pikis Hub</p>
               <p className="text-[11px] text-text-muted leading-tight">Si el usuario acepta tu oferta, la plataforma debitará automáticamente un 5% por referir el cliente calificado.</p>
            </div>

            <div className="flex gap-3 pb-8 mt-4">
              <button 
                onClick={() => setModalAbierto(false)}
                className="w-1/3 py-3 px-4 bg-transparent border border-white/20 rounded-xl font-bold text-sm tracking-wide hover:bg-white/5 active:scale-95 transition-transform"
              >
                Cancelar
              </button>
              <button 
                onClick={enviarCotizacion}
                disabled={enviando}
                className="flex-1 py-3 px-4 bg-gold-cert text-yellow-950 rounded-xl font-black text-sm tracking-wide hover:shadow-[0_0_20px_#fbbf24] active:scale-95 transition-all flex items-center justify-center gap-2"
              >
                <Send className="w-5 h-5 text-yellow-950" />
                {enviando ? 'Tramitando Contrato...' : 'Sellar Oferta Oficial'}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Cierre de Servicio (Postpago B2B) */}
      <AnimatePresence>
        {modalCierreAbierto && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex flex-col justify-center px-6"
          >
            <div className="bg-gradient-to-b from-[#1e293b] to-black border border-green-500/30 rounded-3xl p-6 relative shadow-[0_0_50px_rgba(34,197,94,0.15)] text-center w-full max-w-sm mx-auto">
              <h2 className="text-xl font-black text-white mb-2 flex items-center justify-center gap-2 uppercase tracking-wide">
                 <CheckCircle className="w-6 h-6 text-green-500" /> Cierre de Trabajo
              </h2>
              <p className="text-[11px] text-slate-400 mb-6 px-1 leading-tight">Digita el valor exacto que el cliente de Pikis pagó en tu caja. Sobre esta cifra se cargará la comisión del <strong className="text-white">5%</strong> a tu Estado de Cuenta Quincenal.</p>

              <div className="relative mb-6">
                <span className="absolute left-4 top-[17px] text-text-muted font-bold">$</span>
                <input 
                  type="tel" 
                  value={valorFinal}
                  onChange={e => {
                     let raw = e.target.value.replace(/\D/g, '');
                     if (!raw) { setValorFinal(''); return; }
                     setValorFinal(Number(raw).toLocaleString('es-CO'));
                  }}
                  placeholder="Valor Cobrado Real" 
                  className="w-full p-4 pl-8 rounded-xl border border-slate-700 bg-bg-dark text-white font-bold text-lg outline-none focus:border-green-500 focus:shadow-[0_0_15px_rgba(34,197,94,0.2)] transition-all" 
                />
                {valorFinal && (
                   <p className="text-[10px] text-yellow-500 font-bold mt-2 uppercase tracking-wide">
                     Comisión estimada: ${(parseFloat(valorFinal.replace(/\D/g, '')) * 0.05).toLocaleString('es-CO')}
                   </p>
                )}
              </div>

              <div className="flex gap-3">
                <button 
                  onClick={() => setModalCierreAbierto(false)}
                  className="w-1/3 py-3 bg-white/5 font-bold text-slate-400 text-xs rounded-xl hover:bg-white/10 active:scale-95 transition-all uppercase"
                >
                  Cancelar
                </button>
                <button 
                  onClick={async () => {
                     if (!valorFinal) return alert("Debes ingresar el valor cobrado para legalizar el servicio.");
                     setCerrando(true);
                     const rawVal = parseFloat(valorFinal.toString().replace(/\D/g, ''));
                     const comision = rawVal * 0.05;
                     try {
                        const { error } = await supabase.from('cotizaciones').update({
                           estado: 'ejecutada',
                           valor_final: rawVal,
                           comision_generada: comision
                        }).eq('id', cotizacionActual.id);
                        
                        if (error) throw error;
                        
                        setCotizacionesEnviadas(cotizacionesEnviadas.map(c => c.id === cotizacionActual.id ? {...c, estado: 'ejecutada', valor_final: rawVal, comision_generada: comision} : c));
                        setModalCierreAbierto(false);
                        setValorFinal('');
                        alert("✅ Servicio legalizado correctamente con corte Quincenal. ¡Buen trabajo!");
                     } catch(e) {
                        alert("⚠️ Error: Solicita al Administrador añadir columnas 'valor_final' y 'comision_generada' tipo numérico a la tabla 'cotizaciones' en Supabase.");
                     } finally { setCerrando(false); }
                  }}
                  disabled={cerrando}
                  className="flex-1 py-3 bg-green-600 font-extrabold text-white text-[11px] tracking-wider rounded-xl hover:shadow-[0_0_15px_rgba(34,197,94,0.4)] active:scale-95 transition-all flex justify-center items-center gap-1.5 uppercase"
                >
                  {cerrando ? 'Auditando...' : 'Legalizar Servicio'}
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Interactivo (Código QR Empleados) */}
      <AnimatePresence>
        {qrModalAbierto && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="fixed inset-0 z-[60] bg-[#0f172a]/95 backdrop-blur-sm flex flex-col items-center justify-center p-6 text-center"
          >
            <div className="bg-bg-dark border border-white/10 p-8 pt-10 rounded-3xl shadow-2xl w-full max-w-sm flex flex-col items-center relative">
              <button 
                onClick={() => setQrModalAbierto(false)} 
                className="absolute top-4 right-4 p-1.5 bg-white/5 rounded-full hover:bg-white/10 text-white/50 hover:text-white transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
              <h2 className="text-xl font-black mb-2 flex items-center gap-2">
                <Users className="w-6 h-6 text-primary-cyan" /> 
                Vincular Mecánico
              </h2>
              <p className="text-xs text-text-muted mb-6 leading-relaxed">
                Pídele a tu empleado que descargue MOTOPIKIS Pro y en el Login elija "Entrar con QR". Luego debe escanear este código.
              </p>
              
              <div className="bg-white p-4 rounded-2xl mb-6 shadow-[0_0_30px_rgba(251,191,36,0.2)]">
                <QRCodeSVG value={`TALLER_ACCESO:${perfilTaller.usuario_id}`} size={200} bgColor={"#ffffff"} fgColor={"#000000"} />
              </div>

              <div className="bg-blue-500/10 border border-blue-500/20 p-3 rounded-xl mb-6 text-left w-full">
                <p className="text-[10px] text-blue-400 font-bold uppercase tracking-wide mb-1">Seguridad Financiera</p>
                <p className="text-[10px] text-text-muted">Tu empleado podrá cotizar licitaciones, pero SOLO TÚ recibirás los pagos en tu billetera corporativa.</p>
              </div>

            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal Editar Ficha Técnica */}
      <AnimatePresence>
        {editModalAbierto && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="fixed inset-0 z-[70] bg-[#0f172a]/95 backdrop-blur-md flex flex-col pt-8 px-5 overflow-y-auto"
          >
            <div className="flex justify-between items-center mb-6 border-b border-white/10 pb-4">
               <div>
                  <h2 className="text-xl font-black text-white leading-tight">Directorio MotoPikis</h2>
                  <p className="text-[11px] text-primary-cyan font-bold tracking-widest uppercase mt-0.5">Ficha de tu Sucursal</p>
               </div>
               <button onClick={() => setEditModalAbierto(false)} className="p-2 bg-white/5 rounded-full hover:bg-white/10">
                  <X className="w-5 h-5 text-white" />
               </button>
            </div>
            
            <div className="space-y-3 mb-4 relative z-10 w-full max-w-sm mx-auto">
               <div className="bg-slate-800/80 border border-slate-700 px-4 py-3 rounded-xl shadow-inner">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Nombre Comercial del Taller *</label>
                  <input 
                    type="text" 
                    value={editForm.nombre}
                    onChange={e => setEditForm({...editForm, nombre: e.target.value.toUpperCase()})}
                    maxLength={50}
                    className="w-full bg-transparent text-white font-bold text-sm outline-none placeholder:text-slate-500 border-b border-white/10 focus:border-gold-cert pb-1 transition-colors uppercase"
                  />
               </div>

               <div className="bg-slate-800/80 border border-slate-700 px-4 py-3 rounded-xl shadow-inner">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Especialidad Principal *</label>
                  <textarea 
                    value={editForm.especialidad}
                    onChange={e => setEditForm({...editForm, especialidad: formatSentenceCase(e.target.value)})}
                    placeholder="Ej: Sistemas eléctricos, mecánica general..." 
                    maxLength={100}
                    rows={5}
                    className="w-full bg-transparent text-white font-bold text-sm outline-none placeholder:text-slate-500 border-b border-white/10 focus:border-gold-cert pb-1 transition-colors resize-none leading-tight"
                  ></textarea>
                  <p className="text-[9px] text-text-muted mt-1 leading-tight">Palabras clave con las que te encontrarán en el Directorio.</p>
               </div>

               <div className="bg-slate-800/80 border border-slate-700 px-4 py-3 rounded-xl shadow-inner flex flex-col">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Ciudad Base</label>
                  <input 
                    type="text" 
                    value={editForm.ciudad}
                    onChange={e => setEditForm({...editForm, ciudad: formatSentenceCase(e.target.value)})}
                    placeholder="Ej: Bogotá, Medellín, Cali" 
                    maxLength={40}
                    className="w-full bg-transparent text-white font-bold text-sm outline-none placeholder:text-slate-500 border-b border-white/10 focus:border-gold-cert pb-1 transition-colors"
                  />
               </div>

               <div className="bg-slate-800/80 border border-slate-700 px-4 py-3 rounded-xl shadow-inner flex flex-col">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block mb-1">Dirección Física</label>
                  <input 
                    type="text" 
                    value={editForm.direccion}
                    onChange={e => setEditForm({...editForm, direccion: formatSentenceCase(e.target.value)})}
                    placeholder="Ej: Av. Caracas #45-20 Sur" 
                    maxLength={100}
                    className="w-full bg-transparent text-white font-bold text-sm outline-none placeholder:text-slate-500 border-b border-white/10 focus:border-gold-cert pb-1 transition-colors"
                  />
               </div>
            </div>

            <button 
              onClick={guardarEdicion}
              disabled={guardandoEdicion}
              className="w-full py-4 bg-gradient-to-r from-emerald-600 to-green-500 text-white font-black text-sm uppercase tracking-widest rounded-xl hover:shadow-[0_0_20px_rgba(16,185,129,0.4)] active:scale-95 transition-all outline-none flex items-center justify-center gap-2 mb-10 shrink-0"
            >
              {guardandoEdicion ? <Loader2 className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />}
              {guardandoEdicion ? 'Actualizando Matrix...' : 'Guardar Nueva Ficha'}
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal GPS Éxito */}
      <AnimatePresence>
        {modalGpsExito && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center p-6 text-center"
          >
            <div className="w-full max-w-sm bg-gradient-to-br from-slate-800 to-slate-900 border border-green-500/30 rounded-3xl p-6 relative shadow-[0_10px_40px_rgba(34,197,94,0.15)] text-center overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-full blur-[40px] -mr-10 -mt-10 pointer-events-none"></div>
                <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4 border border-green-500/30 shadow-inner">
                    <CheckCircle className="w-8 h-8 text-green-400" />
                </div>
                <h3 className="text-lg font-black text-white mb-2 uppercase tracking-wide">¡Radares Fijados!</h3>
                <p className="text-xs text-slate-300 leading-relaxed mb-6">Tu ubicación satelital se ha anclado permanentemente en el ecosistema <strong className="text-white">MotoPikis</strong>. Los clientes ahora verán tu distancia real.</p>
                <button onClick={() => setModalGpsExito(false)} className="w-full py-3.5 bg-green-500 hover:bg-green-600 text-white font-black text-[12px] uppercase tracking-widest rounded-xl transition-colors shadow-lg shadow-green-500/20">
                    ENTENDIDO
                </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Modal GPS Reiniciado */}
      <AnimatePresence>
        {modalGpsReinicio && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="fixed inset-0 z-[100] bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center p-6 text-center"
          >
            <div className="w-full max-w-sm bg-gradient-to-br from-slate-800 to-slate-900 border border-yellow-500/40 rounded-3xl p-6 relative shadow-[0_10px_40px_rgba(234,179,8,0.15)] text-center overflow-hidden">
                <div className="absolute top-0 left-0 w-32 h-32 bg-yellow-500/10 rounded-full blur-[40px] -ml-10 -mt-10 pointer-events-none"></div>
                <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4 border border-yellow-500/40 shadow-inner">
                    <AlertOctagon className="w-8 h-8 text-yellow-400" />
                </div>
                <h3 className="text-lg font-black text-yellow-400 mb-2 uppercase tracking-wide">Radar Reiniciado</h3>
                <p className="text-xs text-slate-300 leading-relaxed mb-6">Detectamos un cambio en tu dirección física. Hemos apagado tu señal previa. Por favor oprime el botón rojo en tu nueva ubicación para recalibrar el mapa.</p>
                <button onClick={() => setModalGpsReinicio(false)} className="w-full py-3.5 bg-yellow-500/20 text-yellow-400 border border-yellow-500/40 hover:bg-yellow-500 hover:text-yellow-950 font-black text-[12px] uppercase tracking-widest rounded-xl transition-colors">
                    VOLVER AL PANEL
                </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

    </motion.div>
  );
}
